<template>
    <el-select
        filterable
        remote
        :remote-method="remoteMethod"
        class="search-input"
        v-model="Datas"
        :placeholder="placeholders"
        :clearable="clearables"
        @change="myChange"
        ref="select"
        @hook:mounted="cancalReadOnly"
        @visible-change="visibleChange"
        :multiple="multiple"
        :disabled="disable"
        style="width: 100%"
        :loading="loading"
        :reserve-keyword="false"
        popper-class="optimized-select-dropdown"
    >
        <el-option
            v-for="(item, index) in displayOptions"
            :key="item[keys] || index"
            :label="getOptionLabel(item)"
            :value="item[values] || item"
            :disabled="item['islock'] == 1 ? true : false || item.status == 0"
        >
            <span style="float: left; color: #8492a6; font-size: 13px; margin-right: 10px">
                <el-tag style="margin-right: 10px" type="danger" v-if="item['islock'] == 1 ? true : false">锁定</el-tag>
                {{ item[values] || item }}
            </span>
            <span v-if="!single" style="float: right">{{ item[labels] }}</span>
        </el-option>
    </el-select>
</template>

<script>
export default {
    name: 'OptimizedSelect',
    data() {
        return {
            // 选中时的数据
            Datas: '',
            // 显示的选项（限制数量）
            displayOptions: [],
            // 原始完整数据
            originalOptions: [],
            // 过滤后的数据
            filteredOptions: [],
            // 加载状态
            loading: false,
            // 防抖定时器
            debounceTimer: null,
            // 搜索关键词
            searchKeyword: ''
        };
    },
    props: {
        value: {
            default: ''
        },
        // 初始搜索遍历的数组
        options: {
            type: Array,
            default: () => []
        },
        single: {
            type: Boolean,
            default: false
        },
        values: {
            type: String,
            default: 'value'
        },
        labels: {
            type: String,
            default: 'label'
        },
        keys: {
            type: String,
            default: 'value'
        },
        clearables: {
            type: Boolean,
            default: true
        },
        placeholders: {
            type: String,
            default: '请选择'
        },
        width: {
            type: String,
            default: '200'
        },
        multiple: {
            type: Boolean,
            default: false
        },
        disable: {
            type: Boolean,
            default: false
        },
        // 最大显示数量
        maxDisplay: {
            type: Number,
            default: 100
        },
        // 防抖延迟时间(ms)
        debounceDelay: {
            type: Number,
            default: 300
        }
    },
    watch: {
        options: {
            handler(newVal) {
                if (newVal && Array.isArray(newVal)) {
                    this.originalOptions = newVal;
                    this.filteredOptions = newVal;
                    // 初始显示前N条数据
                    this.displayOptions = newVal.slice(0, this.maxDisplay);
                    // 确保选中的值在显示选项中
                    this.ensureSelectedValueInDisplay();
                }
            },
            deep: true,
            immediate: true
        },
        value: {
            handler(newVal) {
                this.Datas = newVal;
                // 当值发生变化时，确保选中项在显示列表中
                this.$nextTick(() => {
                    this.ensureSelectedValueInDisplay();
                });
            },
            deep: true,
            immediate: true
        }
    },
    mounted() {
        // 判断是否为苹果手机
        var u = navigator.userAgent;
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

        // 监听input事件（主要用于iOS兼容性）
        if (isiOS && this.$refs.select && this.$refs.select.$el) {
            const input = this.$refs.select.$el.querySelector('.el-input__inner');
            if (input) {
                input.addEventListener('input', this.handleIOSInput);

                // 离开时销毁事件监听
                this.$once('hook:beforeDestroy', () => {
                    input.removeEventListener('input', this.handleIOSInput);
                });
            }
        }
    },
    methods: {
        // iOS输入处理
        handleIOSInput(dom) {
            const val = dom.target.value;
            this.remoteMethod(val);
        },

        // 解决苹果手机不能唤起输入法
        cancalReadOnly(onOff) {
            this.$nextTick(() => {
                if (!onOff) {
                    const { select } = this.$refs;
                    if (select && select.$el) {
                        const input = select.$el.querySelector('.el-input__inner');
                        if (input) {
                            input.removeAttribute('readonly');
                        }
                    }
                }
            });
        },

        visibleChange(visible) {
            if (visible) {
                // 下拉框打开时
                if (this.displayOptions.length === 0 && this.originalOptions.length > 0) {
                    this.displayOptions = this.originalOptions.slice(0, this.maxDisplay);
                }
            } else {
                // 下拉框关闭时，重置搜索状态
                this.searchKeyword = '';
                this.filteredOptions = this.originalOptions;
            }
            this.cancalReadOnly();
        },

        // 远程搜索方法（替代原来的filter-method）
        remoteMethod(query) {
            // 清除之前的定时器
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }

            // 设置新的防抖定时器
            this.debounceTimer = setTimeout(() => {
                this.performSearch(query);
            }, this.debounceDelay);
        },

        // 执行搜索
        performSearch(query) {
            this.loading = true;
            this.searchKeyword = query;

            try {
                if (!query) {
                    // 无搜索词时显示原始数据的前N条
                    this.filteredOptions = this.originalOptions;
                    this.displayOptions = this.originalOptions.slice(0, this.maxDisplay);
                } else {
                    // 有过滤词时进行搜索
                    const lowerQuery = query.toLowerCase();
                    this.filteredOptions = this.originalOptions.filter(item => {
                        const valueText = (item[this.values] || '').toString().toLowerCase();
                        const labelText = (item[this.labels] || '').toString().toLowerCase();

                        return valueText.includes(lowerQuery) || labelText.includes(lowerQuery);
                    });

                    // 显示过滤结果的前N条
                    this.displayOptions = this.filteredOptions.slice(0, this.maxDisplay);
                }
            } catch (error) {
                console.error('搜索过程中发生错误:', error);
                this.displayOptions = [];
            } finally {
                this.loading = false;
            }
        },

        // 获取选项标签文本
        getOptionLabel(item) {
            const valueText = item[this.values] || item;
            const labelText = item[this.labels] || '';

            if (this.single || !labelText) {
                return valueText;
            }
            return `${valueText}-${labelText}`;
        },

        // 选择变更事件
        myChange(val) {
            this.$emit('selectChange', this.Datas);
            this.$emit('input', this.Datas);
            // 移除不必要的强制更新
        },

        // 确保选中的值在显示选项中
        ensureSelectedValueInDisplay() {
            if (!this.Datas || this.Datas === '' || !this.originalOptions.length) {
                return;
            }

            // 检查当前选中的值是否已经在显示选项中
            const isSelectedInDisplay = this.displayOptions.some(item =>
                (item[this.values] || item) === this.Datas
            );

            if (!isSelectedInDisplay) {
                // 查找选中的项
                const selectedItem = this.originalOptions.find(item =>
                    (item[this.values] || item) === this.Datas
                );

                if (selectedItem) {
                    // 将选中项添加到显示列表的开头
                    const newDisplayOptions = [selectedItem, ...this.displayOptions];
                    // 保持列表长度不超过maxDisplay
                    this.displayOptions = newDisplayOptions.slice(0, this.maxDisplay);
                }
            }
        }
    },

    beforeDestroy() {
        // 清理定时器
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }
    }
};
</script>

<style scoped>
/* 优化下拉框样式 */
.optimized-select-dropdown {
    max-height: 300px !important;
}

.search-input ::v-deep .el-select-dropdown__list {
    max-height: 280px;
    overflow-y: auto;
}

/* 虚拟滚动相关的样式优化 */
.optimized-select-dropdown .el-scrollbar__wrap {
    max-height: 280px;
}
</style>